import apiClient from "../apiClient";

const resource = "Security";

export default {
 Captcha: () => apiClient.get(`${resource}/captcha`, { params: { _: Date.now() } }),
 Login: payload => apiClient.post(`${resource}/login`, payload),
 LoginStatus: () => apiClient.get(`${resource}/loginStatus`),
 Logout: () => apiClient.post(`${resource}/logout`),
 resetSession: () => apiClient.get(`${resource}/resetSession`),
 ChangePassword: payload => apiClient.put(`${resource}/changePassword`, payload),

};
